import script from "./TablaClasificacionIndividual.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaClasificacionIndividual.vue?vue&type=script&setup=true&lang=ts"

import "./TablaClasificacionIndividual.vue?vue&type=style&index=0&id=2c213f4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c213f4a"]])

export default __exports__